<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input
        v-model="listQuery.stationName"
        placeholder="岗位名称"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="handleFilter"
      />
      <el-select v-model="listQuery.status" placeholder="状态" class="filter-item" style="width: 120px;">
        <el-option label="启用" :value="1" />
        <el-option label="禁用" :value="0" />
      </el-select>
      <el-button v-waves class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">
        搜索
      </el-button>
      <el-button
        class="filter-item"
        style="margin-left: 10px;"
        type="primary"
        icon="el-icon-edit"
        @click="handleCreate"
      >
        添加
      </el-button>
    </div>

    <el-table
      :key="tableKey"
      v-loading="listLoading"
      :data="list"
      border
      fit
      highlight-current-row
      style="width: 100%;"
    >
      <el-table-column label="岗位名称" min-width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.stationName }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="stationCode"
        label="岗位代码"
        min-width="200"
        align="center"
        show-overflow-tooltip
      />
      <el-table-column label="描述" min-width="200" align="center">
        <template slot-scope="{row}">
          <span>{{ row.description }}</span>
        </template>
      </el-table-column>
      <el-table-column min-width="200" align="center">
        <template slot="header">
          <span>绩效考核表</span>
          <el-tooltip placement="top" content="本部门负责人评该岗位员工、部门内员工互评该岗位员工时使用；未配置将无法打分">
            <i class="el-icon-question" />
          </el-tooltip>
        </template>
        <template slot-scope="{row}">
          <el-tag v-if="row.kpiFormKey" size="small">{{ formTitle(row.kpiFormKey) }}</el-tag>
          <el-tag v-else size="small" type="info">未配置</el-tag>
        </template>
      </el-table-column>
      <el-table-column min-width="200" align="center">
        <template slot="header">
          <span>负责人考核表</span>
          <el-tooltip placement="top" content="本部门员工评该岗位负责人时使用；未配置将无法打分">
            <i class="el-icon-question" />
          </el-tooltip>
        </template>
        <template slot-scope="{row}">
          <el-tag v-if="row.leaderFormKey" size="small">{{ formTitle(row.leaderFormKey) }}</el-tag>
          <el-tag v-else size="small" type="info">未配置</el-tag>
        </template>
      </el-table-column>
      <el-table-column min-width="200" align="center">
        <template slot="header">
          <span>全员互评用表</span>
          <el-tooltip placement="top" content="其他被考核部门人员及高管评该岗位人员时使用；未配置将无法打分">
            <i class="el-icon-question" />
          </el-tooltip>
        </template>
        <template slot-scope="{row}">
          <el-tag v-if="row.peerFormKey" size="small">{{ formTitle(row.peerFormKey) }}</el-tag>
          <el-tag v-else size="small" type="info">未配置</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="状态" class-name="status-col" width="100" align="center">
        <template slot-scope="{row}">
          <el-tag :type="row.status | statusFilter">
            {{ row.status === 1 ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="150" align="center">
        <template slot-scope="{row}">
          <span>{{ row.createTime | parseTime('{y}-{m}-{d} {h}:{i}') }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" width="140" class-name="small-padding fixed-width">
        <template slot-scope="{row,$index}">
          <el-dropdown trigger="click" @command="command => handleAction(command, row, $index)">
            <el-button type="primary" size="mini">
              操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="edit">编辑</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 0" command="enabled">启用</el-dropdown-item>
              <el-dropdown-item v-if="row.status === 1" command="disabled">禁用</el-dropdown-item>
              <el-dropdown-item divided command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size" @pagination="getList" />

    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" class="common-dialog">
      <el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="100px" class="common-dialog-form">
        <el-form-item label="岗位名称" prop="stationName">
          <el-input v-model="temp.stationName" placeholder="请输入岗位名称" />
        </el-form-item>
        <el-form-item label="岗位代码" prop="stationCode">
          <el-input v-model="temp.stationCode" placeholder="请输入岗位代码" />
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input v-model="temp.description" type="textarea" :rows="3" placeholder="请输入岗位描述" />
        </el-form-item>
        <el-form-item label="绩效考核表">
          <el-select v-model="temp.kpiFormKey" clearable placeholder="未配置（负责人评该岗位员工、部门内互评将无法打分）" style="width: 100%;">
            <el-option-group v-for="g in formGroups" :key="g.label" :label="g.label">
              <el-option v-for="f in g.forms" :key="f.key" :label="f.title" :value="f.key" />
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="负责人考核表">
          <el-select v-model="temp.leaderFormKey" clearable placeholder="未配置（部门内员工评该岗位负责人时将无法打分）" style="width: 100%;">
            <el-option-group v-for="g in leaderFormGroups" :key="g.label" :label="g.label">
              <el-option v-for="f in g.forms" :key="f.key" :label="f.title" :value="f.key" />
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="全员互评用表">
          <el-select v-model="temp.peerFormKey" clearable placeholder="未配置（其他部门人员/高管评该岗位人员时将无法打分）" style="width: 100%;">
            <el-option v-for="f in peerForms" :key="f.key" :label="f.title" :value="f.key" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="temp.status" class="filter-item" placeholder="请选择状态">
            <el-option v-for="item in statusOptions" :key="item.key" :label="item.display_name" :value="item.key" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getStationList, createStation, updateStation, deleteStation } from '../../../api/station'
import { KPI_FORM_GROUPS, formByKey, formsOfScene, groupFormsByDept, PEER_FORMS } from '../../performance/forms'
import waves from '../../../directive/waves' // waves directive
import Pagination from '../../../components/Pagination' // secondary package based on el-pagination
import { parseTime } from '../../../utils/index'

export default {
  name: 'StationTable',
  components: { Pagination },
  directives: { waves },
  filters: {
    parseTime,
    statusFilter(status) {
      const statusMap = {
        1: 'success',
        0: 'danger'
      }
      return statusMap[status]
    }
  },
  data() {
    return {
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        size: 10,
        stationName: undefined,
        status: undefined
      },
      statusOptions: [
        { key: 1, display_name: '启用' },
        { key: 0, display_name: '禁用' }
      ],
      formGroups: KPI_FORM_GROUPS,
      leaderFormGroups: groupFormsByDept(formsOfScene('EMP_LEADER')),
      peerForms: PEER_FORMS,
      temp: {
        id: undefined,
        stationName: '',
        stationCode: '',
        description: '',
        kpiFormKey: '',
        leaderFormKey: '',
        peerFormKey: '',
        status: 1
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑岗位',
        create: '创建岗位'
      },
      dialogPvVisible: false,
      pvData: [],
      rules: {
        stationName: [{ required: true, message: '岗位名称不能为空', trigger: 'blur' }],
        stationCode: [{ required: true, message: '岗位代码不能为空', trigger: 'blur' }]
      },
      downloadLoading: false
    }
  },
  created() {
    this.getList()
  },
  methods: {
    formTitle(key) {
      const f = formByKey(key)
      return f ? f.title : key
    },
    /** 打分表配置字段归一：空串转 null，避免空串入库 */
    normFormKeys(obj) {
      const keys = ['kpiFormKey', 'leaderFormKey', 'peerFormKey']
      keys.forEach(k => { if (obj[k] === '') obj[k] = null })
      return obj
    },
    handleAction(command, row, index) {
      switch (command) {
        case 'edit':
          this.handleUpdate(row)
          break
        case 'enabled':
          this.handleModifyStatus(row, 'enabled')
          break
        case 'disabled':
          this.handleModifyStatus(row, 'disabled')
          break
        case 'delete':
          this.handleDelete(row, index)
          break
        default:
          break
      }
    },
    handleModifyStatus(row, status) {
      const statusText = status === 'enabled' ? '启用' : '禁用'
      const newStatus = status === 'enabled' ? 1 : 0
      this.$confirm(`此操作将${statusText}该岗位, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const tempData = Object.assign({}, row)
        tempData.status = newStatus
        updateStation(tempData).then(() => {
          this.getList()
          this.$notify({
            title: '成功',
            message: `${statusText}成功`,
            type: 'success',
            duration: 2000
          })
        })
      })
    },
    getList() {
      this.listLoading = true
      const data = {
        page: this.listQuery.page - 1,
        size: this.listQuery.size
      }
      if (this.listQuery.stationName) {
        data.stationName = this.listQuery.stationName
      }
      if (this.listQuery.status !== undefined && this.listQuery.status !== null && this.listQuery.status !== '') {
        data.status = this.listQuery.status
      }
      getStationList(data).then(response => {
        this.list = response.data.content
        this.total = response.data.totalElements

        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    resetTemp() {
      this.temp = {
        id: undefined,
        stationName: '',
        stationCode: '',
        description: '',
        kpiFormKey: '',
        leaderFormKey: '',
        peerFormKey: '',
        status: 1
      }
    },
    handleCreate() {
      this.resetTemp()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createStation(this.normFormKeys(Object.assign({}, this.temp))).then(() => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = this.normFormKeys(Object.assign({}, this.temp))
          updateStation(tempData).then(() => {
            this.getList()
            this.dialogFormVisible = false
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            })
          })
        }
      })
    },
    handleDelete(row, index) {
      this.$confirm('此操作将永久删除该岗位, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteStation(row.id).then(() => {
          this.list.splice(index, 1)
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
            duration: 2000
          })
        })
      })
    }
  }
}
</script>